<script>
import Encoding from 'encoding-japanese'
import BaseButton from '@/components/pc/radio/ipradio/atoms/BaseButton.vue'
import ColorSelectBox from '@/components/pc/radio/ipradio/atoms/ColorSelectBox.vue'
import FormTextBox from '@/components/pc/radio/ipradio/atoms/FormTextBox.vue'
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    BaseButton,
    ColorSelectBox,
    FormTextBox,
    RadioGroup,
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem
  },

  data() {
        // ========== 静的変数 ==========
    const invalidBitmapErrMsg = 'ファイルの種類または画像サイズが適切でないため、ファイルを開けません。'
    const bitmapUnselectedErrMsg = 'ファイルを選択してください。'
    const validBitmapConfig = {
      width: 168,
      height: 64,
      monocrome: true,
    }

    const radioBtnOptions = {
      groupType: Object.keys(BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.GROUP_TYPE).map((key) => {
        return {
          label: BC_TRANS_JP.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.GROUP_TYPE[key],
          value: BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.GROUP_TYPE[key],
        }
      }),
      batteryInfo: Object.keys(BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.BATTERY_INFO)
        .filter((key) => {
          return key !== 'DISABLE'
        })
        .map((key) => {
          return {
            label: BC_TRANS_JP.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.BATTERY_INFO[key],
            value: BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.BATTERY_INFO[key],
          }
        }),
    }

    const selectboxOptions = {
      messageType: Object.keys(BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.MESSAGE_TYPE)
        .filter((key) => {
          return key !== 'DISABLE'
        })
        .map((key) => {
          return {
            label: BC_TRANS_JP.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.MESSAGE_TYPE[key],
            value: BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.MESSAGE_TYPE[key],
          }
        }),
      powerOnLedColor: Object.keys(BC.COMMON.LED_COLOR).map((key) => {
        return {
          label: BC_TRANS_JP.COMMON.LED_COLOR[key],
          value: BC.COMMON.LED_COLOR[key],
        }
      }),
    }


    return {
      radioSettings: null,
      invalidBitmapErrMsg,
      bitmapUnselectedErrMsg,
      validBitmapConfig,
      radioBtnOptions,
      selectboxOptions,
      rules: {},

      // ========== リアクティブ変数 ==========
      form: {
        radioBtn: {
          groupType: radioBtnOptions.groupType[0].value,
          batteryInfo: radioBtnOptions.batteryInfo[0].value,
        },
        selectbox: {
          messageType: selectboxOptions.messageType[0].value,
          powerOnLedColor: selectboxOptions.powerOnLedColor[0].value,
        },
        toggle: {
          customStartUpScreen: false,
          messageType: false,
          powerOnLedColor: false,
          batteryInfo: false,
          selfTest: false,
          wps: false,
        },
        text: {
          messageTypeText: null,
          // バリデーションように前回の値を覚えておく
          prevMessageTypeText: null,
        },
        base64: {
          bitmapFile: null,
        },
      },
      fileInput: null,
      filename: '',
      bitmapUrl: '',
      bitmapErrMsg: null,
      startComposition: false,
      setting: null
    }
  },

  computed: {
    BC() {
      return BC
    }
  },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    },

    'form.toggle.customStartUpScreen': function(newVal) {
      if (newVal === false) {
          this.bitmapErrMsg = null
          this.filename = ''
          this.bitmapUrl = ''
          this.form.base64.bitmapFile = null
      } else if (!this.form.base64.bitmapFile) {
        this.bitmapErrMsg = this.bitmapUnselectedErrMsg
      }
    },

    bitmapErrMsg(newVal) {
      if (newVal) {
          this.$emit('disableSave', true)
      } else {
          this.$emit('disableSave', false)
      }
    }
  },

  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
    this.rules = {
        messageTypeText: [{validator: this.validatemessageTypeText,trigger: 'change',},],
    }
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures['Power-on_Mode']

      console.log('============================')
      console.log(
        'before setting: ',
        JSON.parse(JSON.stringify(this.setting.OptionalFeatures['Power-on_Mode'])),
      )

      data['Power-on']['CustomStart-upScreen'] = this.form.toggle.customStartUpScreen
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data['Power-on'].BitmapFile = this.form.base64.bitmapFile
      data['Power-on'].MessageType = this.form.toggle.messageType
        ? this.form.selectbox.messageType
        : BC.COMMON.TOGGLE.DISABLE
      data['Power-on'].Text =
        this.form.selectbox.messageType ===
        BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.MESSAGE_TYPE.TEXT
          ? this.form.text.messageTypeText || null
          : null
      data['Power-on'].GroupType = this.form.radioBtn.groupType
      data['Power-on']['Power-onLEDColor'] = this.form.toggle.powerOnLedColor
        ? this.form.selectbox.powerOnLedColor
        : BC.COMMON.TOGGLE.DISABLE
      data['Power-on'].BatteryInfo = this.form.toggle.batteryInfo
        ? this.form.radioBtn.batteryInfo
        : BC.COMMON.TOGGLE.DISABLE
      data.Mode.SelfTest = this.form.toggle.selfTest
          ? BC.COMMON.TOGGLE.ENABLE
          : BC.COMMON.TOGGLE.DISABLE
      data.Mode.WPS = this.form.toggle.wps ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      console.log(
          'after setting: ',
          JSON.parse(JSON.stringify(this.setting.OptionalFeatures['Power-on_Mode'])))
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures['Power-on_Mode']

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      this.form.radioBtn.groupType =  data['Power-on'].GroupType
      this.form.radioBtn.batteryInfo =
          data['Power-on'].BatteryInfo !== BC.COMMON.TOGGLE.DISABLE
          ?  data['Power-on'].BatteryInfo
          : this.radioBtnOptions.batteryInfo[0].value
      this.form.selectbox.messageType =
          data['Power-on'].MessageType !== BC.COMMON.TOGGLE.DISABLE
          ?  data['Power-on'].MessageType
          : this.selectboxOptions.messageType[0].value
      this.form.selectbox.powerOnLedColor =
          data['Power-on']['Power-onLEDColor'] !== BC.COMMON.TOGGLE.DISABLE
          ?  data['Power-on']['Power-onLEDColor']
          : this.selectboxOptions.powerOnLedColor[0].value
      this.form.toggle.customStartUpScreen =  data['Power-on']['CustomStart-upScreen'] !== BC.COMMON.TOGGLE.DISABLE
      this.form.toggle.messageType =  data['Power-on'].MessageType !== BC.COMMON.TOGGLE.DISABLE
      this.form.toggle.powerOnLedColor =  data['Power-on']['Power-onLEDColor'] !== BC.COMMON.TOGGLE.DISABLE
      this.form.toggle.batteryInfo =  data['Power-on'].BatteryInfo !== BC.COMMON.TOGGLE.DISABLE
      this.form.text.messageTypeText =  data['Power-on'].Text
      this.form.base64.bitmapFile =  data['Power-on'].BitmapFile
      this.bitmapUrl =  data['Power-on'].BitmapFile
          ? `data:image/bmp;base64,${ data['Power-on'].BitmapFile}`
          : null
      this.form.toggle.selfTest = data.Mode.SelfTest !== BC.COMMON.TOGGLE.DISABLE
      this.form.toggle.wps = data.Mode.WPS !== BC.COMMON.TOGGLE.DISABLE

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleMessageType(value) {
      this.form.selectbox.messageType = value
    },

    handleOpenFile() {
      this.$refs.fileInput.click()
    },

    async isValidBitmapInfo(file) {
      return new Promise((resolve) => {
        const readerArrayBuf = new FileReader()
        readerArrayBuf.onload = () => {
          const result = readerArrayBuf.result
          const view = new DataView(result)

          // BMP ヘッダーの解析
          const width = view.getInt32(18, true) // offset 18: width
          const height = view.getInt32(22, true) // offset 22: height
          const bitDepth = view.getUint16(28, true) // offset 28: bits per pixel

          const isMonochrome = bitDepth === 1
          //console.log(`bmp info: ${width}, ${height}, ${isMonochrome}`)
          if (
              width !== this.validBitmapConfig.width ||
              height !== this.validBitmapConfig.height ||
              isMonochrome !== this.validBitmapConfig.monocrome
          ) {
            resolve(false)
          }
          resolve(true)
        }
        readerArrayBuf.readAsArrayBuffer(file)
      })
    },

    async loadBitmapFile(file) {
      return new Promise((resolve) => {
        // base64データ & url取得
        const reader = new FileReader()
        reader.onload = () => {
          const result = reader.result
          this.form.base64.bitmapFile = result.split(',')[1]
          this.bitmapUrl = result

          // 確認用
          // this.saveAsBmp(this.form.base64.bitmapFile)
        }
        reader.readAsDataURL(file)
        resolve()
      })
    },

    async handleFileChange(fileChangeEvent) {
      const file = fileChangeEvent.target.files[0]

      if (!file) return

      if (!(await this.isValidBitmapInfo(file))) {
        this.filename = null
        this.form.base64.bitmapFile = null
        this.bitmapUrl = null
        this.bitmapErrMsg = this.invalidBitmapErrMsg
        return
      }
      this.bitmapErrMsg = null

      // ファイル名格納
      this.filename = file.name

      await this.loadBitmapFile(file)
    },
    validatemessageTypeText(rule, value, callback) {
      if (!value) return callback();


      // 定義
      const allowedKu = (ku) => (ku >= 1 && ku <= 8) || ku === 13 || (ku >= 16 && ku <= 84);

      const encodeSjis = (s) => Encoding.convert(Encoding.stringToCode(s), { to: 'SJIS', from: 'UNICODE', type: 'array' });

      const decodeSjis = (bytes) => Encoding.codeToString(Encoding.convert(bytes, { to: 'UNICODE', from: 'SJIS', type: 'array' }));

      const sjisToKuTen = (b1, b2) => {
          let j1 =
          (b1 >= 0x81 && b1 <= 0x9F) ? (b1 - 0x81) * 2 + 0x21 :
          (b1 >= 0xE0 && b1 <= 0xEF) ? (b1 - 0xC1) * 2 + 0x21 :
          null;
          if (j1 == null) return null;

          let j2;
          if (b2 >= 0x9F && b2 <= 0xFC) { j1 += 1; j2 = b2 - 0x7E; }
          else if (b2 >= 0x40 && b2 <= 0x7E) j2 = b2 - 0x1F;
          else if (b2 >= 0x80 && b2 <= 0x9E) j2 = b2 - 0x20;
          else return null;

          const ku = j1 - 0x20, ten = j2 - 0x20;
          return (ku >= 1 && ku <= 94 && ten >= 1 && ten <= 94) ? { ku, ten } : null;
      };
      // 定義


      // フィルタしつつ SJIS 換算14バイト以内で打ち切り
      let out = '';
      let used = 0;

      for (const ch of value) {
          const cp = ch.codePointAt(0);
          if (cp < 0x20 && ch !== ' ') continue;

          let bytes;
          try { bytes = encodeSjis(ch); } catch { continue; }
          if (!bytes || bytes.length < 1 || bytes.length > 2) continue;

          // 往復一致（置換・互換変換を排除）
          if (decodeSjis(bytes) !== ch) continue;

          if (bytes.length === 1) {
          const b = bytes[0];
          if (!((b >= 0x20 && b <= 0x7E) || (b >= 0xA1 && b <= 0xDF))) continue;
          } else {
          const kt = sjisToKuTen(bytes[0], bytes[1]);
          if (!kt || !allowedKu(kt.ku)) continue;
          }

          if (used + bytes.length > 14) break; // 元コード同様「入らない最初の文字」で打ち切り
          out += ch;
          used += bytes.length;
      }

      this.form.text.messageTypeText = out;
      this.form.text.prevMessageTypeText = this.form.text.messageTypeText
      callback();
    },

    // 確認用
    /*
    saveAsBmp(data) {
      // Base64 → バイナリデータ（Blob）に変換
      const byteCharacters = atob(data)
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i))
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'image/bmp' })

      // ダウンロードリンクを作成してクリック
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'output.bmp'
      link.click()

      // メモリ解放
      URL.revokeObjectURL(link.href)
    }
    */
  }
}
</script>

<template>
  <div>
    <SettingGroup title="電源オン">
      <SettingItem label="起動画面">
        <ToggleSwitch v-model="form.toggle.customStartUpScreen" :disable="false" />
      </SettingItem>
      <SettingItem label="ビットマップ・ファイル">
        <div>
          <BaseButton
            type="primary"
            :disable="!form.toggle.customStartUpScreen"
            label="ファイルを選択"
            @click="handleOpenFile()"
          />
          <div v-show="bitmapErrMsg" class="fileError">
            {{ bitmapErrMsg }}
          </div>
        </div>
        <input
          type="file"
          ref="fileInput"
          class="fileInput"
          accept=".bmp"
          @change="handleFileChange"
        />
        <div
          v-show="form.base64.bitmapFile"
          class="bitmapAreaWrapper"
          :class="{ invaidBitmap: !form.toggle.customStartUpScreen }"
        >
          <!-- 保存済みの場合ファイル名は表示できないのでv-ifで制御 -->
          <div v-if="filename" class="filename">{{ filename }}</div>
          <img :src="bitmapUrl" />
        </div>
      </SettingItem>
      <SettingItem label="起動メッセージ">
        <ToggleSwitch v-model="form.toggle.messageType" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.messageType"
          :options="selectboxOptions.messageType"
          :defaultValue="form.selectbox.messageType"
          @update="handleMessageType"
        />
        <el-form
          v-show="
            form.selectbox.messageType === BC.OPTIONAL_FEATURES.POWER_ON_MODE.POWER_ON.MESSAGE_TYPE.TEXT &&
            form.toggle.messageType
          "
          :model="form.text"
          :rules="rules"
        >
          <FormTextBox
            v-model="form.text.messageTypeText"
            label=""
            :disable="false"
            :required="false"
            class="messageTypeTextBox"
            prop="messageTypeText"
          />
        </el-form>
      </SettingItem>
      <SettingItem label="グループタイプ">
        <RadioGroup
          v-model="form.radioBtn.groupType"
          :options="radioBtnOptions.groupType"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="電源オン時の LED 色">
        <ToggleSwitch v-model="form.toggle.powerOnLedColor" :disable="false" />
        <ColorSelectBox
          :input-value="form.selectbox.powerOnLedColor"
          @update:inputValue="form.selectbox.powerOnLedColor = $event"
          :disable="!form.toggle.powerOnLedColor"
        />
      </SettingItem>
      <SettingItem label="電池情報">
        <ToggleSwitch v-model="form.toggle.batteryInfo" :disable="false" />
        <RadioGroup
          v-model="form.radioBtn.batteryInfo"
          :options="radioBtnOptions.batteryInfo"
          :disable="!form.toggle.batteryInfo"
        />
      </SettingItem>
    </SettingGroup>
    <SettingGroup title="モード">
       <SettingItem label="自己診断">
           <ToggleSwitch v-model="form.toggle.selfTest" :disable="false" />
       </SettingItem>
       <SettingItem label="WPS">
           <ToggleSwitch v-model="form.toggle.wps" :disable="false" />
       </SettingItem>
    </SettingGroup>
  </div>
</template>

<style scoped>
.fileError {
  margin-top: 10px;
  color: red;
}

.bitmapAreaWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bitmapAreaWrapper .filename {
  margin-bottom: 10px;
}

.invaidBitmap {
  opacity: 0.5;
}

.messageTypeTextBox {
  width: 300px;
}

.fileInput {
  display: none;
}
</style>
